import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));

// Recipe Management routing
// Steep
const AppNestedSteep = Loadable(lazy(() => import('views/recipes/Steep')));
const AppSteepFillDrain = Loadable(lazy(() => import('views/recipes/Steep/Steps/StepGrids/RecipeSteepFillDrain')));

// Germ
const AppNestedGerm = Loadable(lazy(() => import('views/recipes/Germ')));
const AppGermAirOff = Loadable(lazy(() => import('views/recipes/Germ/Steps/StepGrids/RecipeGermAirOff')));
const AppGermAirOn = Loadable(lazy(() => import('views/recipes/Germ/Steps/StepGrids/RecipeGermAirOn')));
const AppGermTurn = Loadable(lazy(() => import('views/recipes/Germ/Steps/StepGrids/RecipeGermTurn')));

// Kiln
const AppNestedKiln = Loadable(lazy(() => import('views/recipes/Kiln')));
const AppKilnAirOn = Loadable(lazy(() => import('views/recipes/Kiln/Steps/StepGrids/RecipeKilnAirOn')));
const AppKilnRecirc = Loadable(lazy(() => import('views/recipes/Kiln/Steps/StepGrids/RecipeKilnRecirc')));
const AppKilnTurn = Loadable(lazy(() => import('views/recipes/Kiln/Steps/StepGrids/RecipeKilnTurn')));

// Steep
const AppNestedRoast = Loadable(lazy(() => import('views/recipes/Roast')));
const AppRoastReduct = Loadable(lazy(() => import('views/recipes/Roast/Steps/StepGrids/RecipeRoastReduct')));

//Tools
//Counting
const AppCounting = Loadable(lazy(() => import('views/tools/Counting')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: '/',
            element: <DashboardDefault />
        },
        {
            path: '/recipes/kiln',
            element: <AppNestedKiln />,
            children: [
                {
                    path: 'AirOn',
                    element: <AppKilnAirOn />
                },
                {
                    path: 'Recirc',
                    element: <AppKilnRecirc />
                },
                {
                    path: 'TurnSchedule',
                    element: <AppKilnTurn />
                }
            ]
        },
        {
            path: '/recipes/steep',
            element: <AppNestedSteep />,
            children: [
                {
                    path: 'FillDrain',
                    element: <AppSteepFillDrain />
                }
            ]
        },
        {
            path: '/recipes/germ',
            element: <AppNestedGerm />,
            children: [
                {
                    path: 'AirOff',
                    element: <AppGermAirOff />
                },
                {
                    path: 'AirOn',
                    element: <AppGermAirOn />
                },
                {
                    path: 'TurnSchedule',
                    element: <AppGermTurn />
                }
            ]
        },
        {
            path: '/recipes/roast',
            element: <AppNestedRoast />,
            children: [
                {
                    path: 'reduct',
                    element: <AppRoastReduct />
                }
            ]
        },
        {
            path: '/tools',
            children: [
                {
                    path: 'cyclecount',
                    element: <AppCounting />
                }
            ]
        },
        {
            path: '/',
            element: <DashboardDefault />
        }
    ]
};

export default MainRoutes;
